import { Edit } from "react-admin";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { useNotification } from "../../../common/hooks/useNotification";
import { EditActions } from "../../common/form/FormActions";
import { FormToolbar } from "../../common/form/FormToolbar";
import { FuelProviderForm } from "./FuelProviderForm";

interface Props {}

export const FuelProviderEdit = (props: Props) => {
  const notify = useNotification(props, "editSuccess");
  const permissions = useActionPermissions();
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.admin-fuel-providers.title.edit">
      <FuelProviderForm
        toolbar={
          <FormToolbar
            showDeleteButton={
              permissions &&
              permissions[permissionNames.admin.fuelProviders.main] &&
              permissions[permissionNames.admin.fuelProviders.delete]
            }
          />
        }
      />
    </Edit>
  );
};
